import { SearchPage } from 'Components'
import TemplateMainContent from 'Stores/tkhuby6608-1806897/Templates/MainContent.rt'
import { FacetTiles } from 'Components'
import TemplatefacetTilessubtitles from 'Stores/_default-store/Templates/facetTiles/subtitles.rt'
import { FacetPanel } from 'Components'
import { SearchResult } from 'Components'
import { SearchHeader } from 'Components'
import TemplateSearchPageHeader from 'Stores/tkhuby6608-1806897/Templates/SearchPageHeader.rt'
import { SearchBox } from 'Components'
import TemplateSearchBox from 'Stores/_default-store/Templates/SearchBox.rt'
import { SingleVehicleGarage } from 'Components'
import TemplatefitmentSearchsingleVehicleGarage from 'Stores/tkhuby6608-1806897/Templates/fitmentSearch/singleVehicleGarage.rt'
import { VehicleWidget } from 'Components'
import { VerifyFitment } from 'Components'
import TemplatefitmentSearchverifyFitment from 'Stores/tkhuby6608-1806897/Templates/fitmentSearch/verifyFitment.rt'
import { FitmentTable } from 'Components'
import TemplatefitmentSearchfitmentTable from 'Stores/tkhuby6608-1806897/Templates/fitmentSearch/fitmentTable.rt'
import TemplatefitmentSearchfitmentTableTab from 'Stores/tkhuby6608-1/Templates/fitmentSearch/fitmentTableTab.rt'
import TemplatefacetTilesalphabeticalContainer from 'Stores/_default-store/Templates/facetTiles/alphabeticalContainer.rt'
import { FacetDialog } from 'Components'
import TemplateFacetDialog from 'Stores/tkhuby6608-1/Templates/FacetDialog.rt'
import { SearchBoxDialog } from 'Components'
import TemplateSearchBoxDialog from 'Stores/_default-store/Templates/SearchBoxDialog.rt'
import TemplatefitmentSearchhomeVehicleWidget from 'Stores/tkhuby6608-1806897/Templates/fitmentSearch/homeVehicleWidget.rt'
import { ContextDialog } from 'Components'
import TemplateProductInformationDialog from 'Stores/tkhuby6608-1806897/Templates/ProductInformationDialog.rt'
import { SearchBoxDialogButton } from 'Components'
import TemplatesearchBoxdialogButtonMobile from 'Stores/_default-store/Templates/searchBox/dialogButtonMobile.rt'
import { VehicleWidgetDialog } from 'Components'
import TemplatefitmentSearchdialog from 'Stores/tkhuby6608-1/Templates/fitmentSearch/dialog.rt'

export const compMap = {
  SearchPage,
FacetTiles,
FacetPanel,
SearchResult,
SearchHeader,
SearchBox,
SingleVehicleGarage,
VehicleWidget,
VerifyFitment,
FitmentTable,
FacetDialog,
SearchBoxDialog,
ContextDialog,
SearchBoxDialogButton,
VehicleWidgetDialog
}
export const tplMap = {
  'MainContent': TemplateMainContent,
'facetTiles/subtitles': TemplatefacetTilessubtitles,
'SearchPageHeader': TemplateSearchPageHeader,
'SearchBox': TemplateSearchBox,
'fitmentSearch/singleVehicleGarage': TemplatefitmentSearchsingleVehicleGarage,
'fitmentSearch/verifyFitment': TemplatefitmentSearchverifyFitment,
'fitmentSearch/fitmentTable': TemplatefitmentSearchfitmentTable,
'fitmentSearch/fitmentTableTab': TemplatefitmentSearchfitmentTableTab,
'facetTiles/alphabeticalContainer': TemplatefacetTilesalphabeticalContainer,
'FacetDialog': TemplateFacetDialog,
'SearchBoxDialog': TemplateSearchBoxDialog,
'fitmentSearch/homeVehicleWidget': TemplatefitmentSearchhomeVehicleWidget,
'ProductInformationDialog': TemplateProductInformationDialog,
'searchBox/dialogButtonMobile': TemplatesearchBoxdialogButtonMobile,
'fitmentSearch/dialog': TemplatefitmentSearchdialog
};